import React, { forwardRef, useRef } from 'react'
import UpOutlined from '@ant-design/icons/UpOutlined'
import DownOutlined from '@ant-design/icons/DownOutlined'
import classNames from 'classnames'

import styles from './index.less'

export default forwardRef(({ children, collapsed, onCollapse, onHandle }, ref) => {
    const subViewRef = useRef(null)

    // 收起
    const fold = () => {
        if (!subViewRef.current) {
            return
        }

        subViewRef.current.classList.add(styles.hide)
    }

    // 展开
    const expand = () => {
        if (!subViewRef.current) {
            return
        }

        subViewRef.current.classList.remove(styles.hide)
    }

    const toggle = bool => {
        if (bool) {
            fold()
        } else {
            expand()
        }
    }

    onHandle &&
        onHandle({
            fold,
            expand,
            toggle,
            getSubviewRect() {
                return subViewRef.current.getBoundingClientRect()
            }
        })

    const btn = collapsed ? (
        <a className={classNames(styles.btn, styles.expandBtn)} onClick={() => onCollapse(false)}>
            展开
            <DownOutlined className={styles.arrow} />
        </a>
    ) : (
        <a className={classNames(styles.btn, styles.foldBtn)} onClick={() => onCollapse(true)}>
            收起
            <UpOutlined className={styles.arrow} />
        </a>
    )

    return (
        <div
            ref={ref}
            className={classNames(styles.container, {
                [styles.hasExpand]: !collapsed,
                [styles.hasCollapsed]: collapsed
            })}>
            <div
                ref={subViewRef}
                className={classNames({
                    [styles.hide]: collapsed
                })}>
                {children}
            </div>
            <div className={styles.trigger}>
                <div className={styles.background} />
            </div>
            <div className={styles.wrap}>
                <div className={styles.leftLine} />
                {btn}
                <div className={styles.rightLine} />
            </div>
        </div>
    )
})
